import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/Bg-ios-dubai.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>Your Preferable Flutter App Development Company in Dubai</h2>
            </div>
            <p>
              We have enough experience to facilitate the different scales of
              Flutter app development projects from startup to enterprise level.
              You can share your vision and leave it up to our experts to
              transform it into a full-fledged application. Moreover, there are
              multiple solutions that you can choose from our Flutter app
              development services. Our professionals will guide you throughout
              the whole development process, starting from the basics to complex
              functionalities.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book A Consultation Today!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
